export default Object.freeze({
  credit: 30,
  refund: 31,
  enpCredit: 45,
});
